import React, { useEffect, useState } from "react";
import {DKTooltipWrapper, DKIcon, DKLabel, DKButton, showToast, TOAST_TYPE, showAlert,showLoader,removeLoader} from "deskera-ui-library";
import Utility, { deepClone } from "../../../../../utility/Utility";
import ic_arrow_back from "../../../../../assets/icons/ic_arrow_back.svg";
import RouteManager, { PAGE_ROUTES } from "../../../../../managers/RouteManager";
import { IRAS_TAB } from "../../../../../constants/Enum"
import AISSubmissionFieldSection from "./AISSubmissionFieldSection";
import {IRAS_MESSAGES, IRAS_SUBMISSION_FIELDS} from "../SGReportsConstant"
import EmployeeListService from "../../../../../services/EmployeeListService";
import { fetchCPFAccount } from "../../../../../Redux/Slices/EmployeeListSlice";
import { useDispatch } from "react-redux";
import IRASSubmission from "./IRASSubmission";
import IRASSubmittedFile from "./IRASSubmittedFile";
import IRASSubmissionLogs from "./IRASSubmissionLogs";
import { TENANT, TenantService } from "../../../../../managers/TenantManagerService";
import IRASService from "../../../../../services/IRASService";
import ApiConstants from "../../../../../constants/ApiConstants";
import { getQueryParam } from "../../../../../managers/common/CommonUtil";

const AISSubmission = (props) => {

    /**Hooks */
    let tabIndex = getQueryParam(props.location, "tabIndex");
    const [activeTab, setActiveTab] = useState(!Utility.isEmpty(tabIndex) && tabIndex === "2" ? IRAS_TAB.IRAS_SUBMISSION_VALIDATION_LOG :IRAS_TAB.IRAS_SUBMISSION);
    const [submissionData, setSubmissionData] = useState({
        isGridEnabled : false,
        params: {},
        isUpdateTrigerred: true
    });
    const [submittedFieldData, setSubmittedFieldData] = useState({
        isGridEnabled : false,
        params: {},
        isUpdateTrigerred: true
    });
    const [submissionLogData, setSubmissionLogData] = useState({
        isGridEnabled : false,
        params: {},
        isUpdateTrigerred: true
    })
    const [sectionValues,setSectionValues] = useState({
        formValues: {
            'bypass':{id:true, name: "True"}
        }
    });
    const [selectedRow, setSelectedRow] = useState([]);

    /**Selectors */

    /**Dispatcher */
    const dispatch = useDispatch();

    useEffect(() => {
        RouteManager.setPresenter({props: props});
        loadCPFAccountDetails();
    },[])


    const loadCPFAccountDetails = async () => {
        try {
          const config = {
            Limit: 100,
            currentPage: 1,
            order: undefined,
            field: undefined,
            searchString: undefined,
          };
          EmployeeListService.apiConfig = config;
          await dispatch(fetchCPFAccount());
        } catch (err) {
          console.error("Error loading CPF Accounts data: ", err);
        }
    };

    const updateFormValues = (data) => {
        setSectionValues(data);
    }

    const routeToOrigin = () => {
        RouteManager.navigateToPage(PAGE_ROUTES.REPORTS_LIST);
    }

    const getButtonAction = (action) => {
        switch(action) {
            case "CANCEL":
                RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
                break;
            case "VALIDATE":
                validateSubmissionConfirmationPopup();
                break;
            case "VALIDATE_AND_SUBMIT":
                validateAndSubmitSubmissionConfirmationPopup();
                break;
        }
    }

    const validateSubmissionConfirmationPopup = () =>{
        const validateConfirm = [
            {
                title: "No",
                className: "bg-gray1 border-m",
            },
            {
                title: "Yes",
                className: "bg-red text-white ml-r",
                onClick: () => validateRecord(),
            },
        ]
        showAlert(
            IRAS_MESSAGES.VALIDATE_RECORDS,
            IRAS_MESSAGES.VALIDATE_CONFIRMATION,
            validateConfirm
          );
    }

    const getQueryParameters = (isValidateOnly) => {
        let parameters = {};
        parameters['year'] = submissionData.params['year'];
        parameters['cpfAccountId'] = submissionData.params['cpfAccountId'];
        parameters['authorizedUserId'] = TenantService.get(TENANT.USER_ID);
        parameters['validateOnly'] = isValidateOnly;
        parameters['isFromNewSetup'] = false;
        parameters['redirectURL'] = ApiConstants.AIS_APPLICATION_REDIRECT_URL;
        parameters['bypass'] = submissionData.params['bypass']
        return parameters;
    }

    const getEmployeeDetails = () => {
        let details = {};
        const employeeDetails = [];
        selectedRow?.forEach((row) => {
            let group = {
                designation: row.designation,
                employeeId: row.empId,
                fin: row.fin,
                firstName: row.firstName,
                formStatus: row.formStatus,
                iamUserId: row.iamUserId,
                lastName: row.lastName,
                nric: row.nric,
                userId: row.userId
            }
            employeeDetails.push(group);
        });
        details['employees'] = employeeDetails;
        return details;
    }

    const validateRecord = () => {
        const parameters = getQueryParameters(true);
        const detailsData =  getEmployeeDetails();
        showLoader() 
        IRASService.validateSubmitedUsers(parameters, detailsData).then((response) => {
            if (response && response.url) {
                const corpassUrl = response.url;
                window.open(corpassUrl, '_self');
              } else {
                removeLoader()
              }
        },error=>{
            removeLoader()
        })
    }

    const validateAndSubmitSubmissionConfirmationPopup = () =>{
        const validateConfirm = [
            {
                title: "No",
                className: "bg-gray1 border-m",
            },
            {
                title: "Yes",
                className: "bg-red text-white ml-r",
                onClick: () => validateAndSubmitRecord(),
            },
        ]
        showAlert(
            IRAS_MESSAGES.VALIDATE_SUBMIT_RECORS,
            IRAS_MESSAGES.VALIDATE_AND_SUBMIT_CONFIRMATION,
            validateConfirm
          );
    }

    const validateAndSubmitRecord = () => {
        const parameters = getQueryParameters(false);
        const detailsData =  getEmployeeDetails();
        showLoader()
        IRASService.validateSubmitedUsers(parameters, detailsData).then((response) => {
            if (response && response.url) {
                const corpassUrl = response.url;
                window.open(corpassUrl, '_self');
              } else {
                removeLoader()
              }
        },error=>{
            removeLoader()
        })
    }


    const changeActiveTab = (tabName) => {
        setActiveTab(tabName);
    }

    const fetchSubmissionLogs = (params) => {
        setSubmissionLogData({
            isGridEnabled:true,
            params: params,
            isUpdateTrigerred:true
        });
    }

    const fetchIRASSubmittedData = (params) => {
        setSubmittedFieldData({
            isGridEnabled:true,
            params: params,
            isUpdateTrigerred:true
        });
    }

    const fetchIRASSubmission = (params) => {
        setSubmissionData({
            isGridEnabled:true,
            params: params,
            isUpdateTrigerred:true
        });
    }

    const onRowSelection = (data) => {
        const submissionConfig = deepClone(submissionData);
        submissionConfig.isUpdateTrigerred = false;
        setSubmissionData(submissionConfig);
        setSelectedRow(data);
    }

    const isValidateAndSubmitEnabled = ()  =>{
        let isIR8ASubmitted = false;
        if (selectedRow && selectedRow.length > 0) {
          for (let item = 0; item < selectedRow.length; item++) {
            let formStatus = selectedRow[item].formStatus;
            if (formStatus) {
              for (let index = 0; index < formStatus.length; index++) {
                let record = formStatus[index];
                if (record && record.type === 'IR8A') {
                  if (record.isGenerated) {
                    isIR8ASubmitted = true;
                  } else {
                    isIR8ASubmitted = false;
                    return isIR8ASubmitted;
                  }
                }
              }
            }
          }
        }
        return isIR8ASubmitted;
      }

    const getTabSection = () => {
        return (
            <>
                <div className="row row-responsive parent-width justify-content-between border-radius-s mt-m">
                    <div className="row row-responsive parent-width">
                        <div
                            className={"cursor-hand fs-r"}
                            style={{
                                padding: 14,
                                borderBottom:
                                    activeTab === IRAS_TAB.IRAS_SUBMISSION
                                        ? "2px solid #006641"
                                        : "none",
                                fontWeight: activeTab === IRAS_TAB.IRAS_SUBMISSION ? 700 : 400,
                            }}
                            onClick={() => changeActiveTab(IRAS_TAB.IRAS_SUBMISSION)}
                        >
                            {IRAS_TAB.IRAS_SUBMISSION}
                        </div>
                        <div
                            className={"cursor-hand fs-r ml-m"}
                            style={{
                                padding: 14,
                                borderBottom:
                                    activeTab === IRAS_TAB.IRAS_SUBMITTED_FILE
                                        ? "2px solid #006641"
                                        : "none",
                                fontWeight: activeTab === IRAS_TAB.IRAS_SUBMITTED_FILE ? 700 : 400,
                            }}
                            onClick={() => changeActiveTab(IRAS_TAB.IRAS_SUBMITTED_FILE)}
                        >
                            {IRAS_TAB.IRAS_SUBMITTED_FILE}
                        </div>
                        <div
                            className={"cursor-hand fs-r ml-m"}
                            style={{
                                padding: 14,
                                borderBottom:
                                    activeTab === IRAS_TAB.IRAS_SUBMISSION_VALIDATION_LOG
                                        ? "2px solid #006641"
                                        : "none",
                                fontWeight: activeTab === IRAS_TAB.IRAS_SUBMISSION_VALIDATION_LOG ? 700 : 400,
                            }}
                            onClick={() => changeActiveTab(IRAS_TAB.IRAS_SUBMISSION_VALIDATION_LOG)}
                        >
                            {IRAS_TAB.IRAS_SUBMISSION_VALIDATION_LOG}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const getHeaderSection = () => {
        return(
            <>
                <div className="row">
                    <div className="row align-items-center">
                        <div onClick={() => routeToOrigin()}>
                            <DKTooltipWrapper
                                content="Back to Report list"
                                tooltipClassName="warning-tooltip-prop"
                            >
                                <DKIcon src={ic_arrow_back} className="ic-s mr-r cursor-hand" />
                            </DKTooltipWrapper>
                        </div>
                        <DKLabel text="IRAS AIS Submission" className="fw-m fs-l" />
                    </div>
                    <div className="row" style={{justifyContent:"flex-end"}}>
                        {activeTab === IRAS_TAB.IRAS_SUBMISSION && (
                        <>
                            <DKButton
                            title={"Cancel"}
                            className="border-m bg-gray1"
                            onClick={() => {
                                getButtonAction("CANCEL");
                            }}
                        />
                        <DKButton
                            title={"Validate"}
                            className={`border-m ml-r text-white ${selectedRow.length === 0 ? "bg-gray" : "bg-button" }`}
                            onClick={() => {
                                getButtonAction("VALIDATE");
                            }}
                            disabled={selectedRow.length === 0}
                        />
                        <DKButton
                            title={"Validate and Submit"}
                            className={`border-m ml-r text-white ${!isValidateAndSubmitEnabled() ? "bg-gray" : "bg-button"}`}
                            onClick={() => {
                                getButtonAction("VALIDATE_AND_SUBMIT");
                            }}
                            disabled={!isValidateAndSubmitEnabled()} 
                        />
                        </>
                        )}
                    </div>
                </div>
            </>
        )
    }

    return(
        <>
            <div className="parent-width">
                {getHeaderSection()}
                {getTabSection()}
                {activeTab === IRAS_TAB.IRAS_SUBMISSION && <AISSubmissionFieldSection formConfig={IRAS_SUBMISSION_FIELDS[IRAS_TAB.IRAS_SUBMISSION]} fetchIRASSubmission={(data) => fetchIRASSubmission(data)} updatePropsValue={(data) => updateFormValues(data)} formValues={sectionValues.formValues} />}
                {activeTab === IRAS_TAB.IRAS_SUBMITTED_FILE && <AISSubmissionFieldSection formConfig={IRAS_SUBMISSION_FIELDS[IRAS_TAB.IRAS_SUBMITTED_FILE]} fetchIRASSubmittedData={(data) => fetchIRASSubmittedData(data)} updatePropsValue={(data) => updateFormValues(data)} formValues={sectionValues.formValues} />}
                {activeTab === IRAS_TAB.IRAS_SUBMISSION_VALIDATION_LOG && <AISSubmissionFieldSection formConfig={IRAS_SUBMISSION_FIELDS[IRAS_TAB.IRAS_SUBMISSION_VALIDATION_LOG]} fetchSubmissionLogs={(data) => fetchSubmissionLogs(data)} updatePropsValue={(data) => updateFormValues(data)} formValues={sectionValues.formValues} />}
                {activeTab === IRAS_TAB.IRAS_SUBMISSION && submissionData.isGridEnabled && <IRASSubmission data={submissionData} onRowSelection={(data) => onRowSelection(data)} />}
                {activeTab === IRAS_TAB.IRAS_SUBMITTED_FILE && submittedFieldData.isGridEnabled && <IRASSubmittedFile data={submittedFieldData} />}
                {activeTab === IRAS_TAB.IRAS_SUBMISSION_VALIDATION_LOG && submissionLogData.isGridEnabled && <IRASSubmissionLogs data={submissionLogData} />}
            </div>
        </>
    )

}

export default AISSubmission;